import { ThreeDots, TailSpin } from "react-loader-spinner";
import { toggleMenu } from "../../utils/helpers";
import Pagination from "../../components/Pagination";
import Footer from "../../components/Footer";
import { useEffect, useState } from "react";
import {
  API_EMPLOYEE_REIMBURSEMENT_LIST,
  API_REIMBURSEMENT_LIST,
  API_GET_EMPLOYEE_FILE,
  GET_EMPLOYEE_LIST,
} from "../../config/Endpoints";
import Cookies from "js-cookie";
import { getApi } from "../../utils/api";
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import PageTitle from "../../components/PageTitle";
import { generateMonths, getYearsUpToCurrent } from "../../utils/helpers";
import { displayFormatDate } from "../../utils/helpers";
import SortableTable from "../../components/SortableTable";
import axios from "axios";
import DocumentViewer from "../../components/DocumentViewer";
import ReimbursementAmount from "../../components/ReimbursementAmount";

const ReimbursementHistory = ({ title, description }) => {
  const [reimbursementList, setReimbursementList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEmployeeLoading, setIsEmployeeLoading] = useState(false);

  const [filteredItems, setFilteredItems] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [months, setMonths] = useState(generateMonths());
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "",
  });
  const [employeeList, setEmployeeList] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalReimbursement, setTotalReimbursement] = useState(0);
  const accessToken = Cookies.get("accessToken");
  const param = (val) => (val ? String(val).trim() : "");
  const [documentDetail, setDocumentDetail] = useState({
    url: null,
    type: null,
    name: null,
  });

  const columns = [
    {
      key: "employeeName",
      label: "Employee Name",
    },
    {
      key: "reimbursementType",
      label: "Reimbursement Type",
    },
    {
      key: "requestDate",
      label: "Requested Date",
      render : (row) => displayFormatDate(row.requestDate),
      compare: (a, b) =>
        new Date(a.requestDate) - new Date(b.requestDate),
    },
    {
      key: "date",
      label: "Invoice Date",
      render: (row) => displayFormatDate(row.date),
      compare: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      key: "invoiceNo",
      label: "Invoice No.",
    },
    {
      key: "reimbursementAmount",
      label: "Amount",
      render: (row) => (
        <ReimbursementAmount
          amount={row.reimbursementAmount.toLocaleString("en-IN")}
          currencyType={row.currencyType}
        />
      ),
    },
    {
      key: "trackingStatus",
      label: "Status",
    },
    {
      key: "download",
      label: "Action",
      sortable: false,
      render: (row) =>
        row.filePath ? (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleViewFile(row.filePath, `Invoice_${row.invoiceNo}`);
            }}
          >
            View
          </a>
        ) : (
          "-"
        ),
    },
  ];

  const handleViewFile = async (fullPath, name) => {
    const filepath = fullPath.split("/").slice(3).join("/");
    setIsDownloading(true);
    try {
      const res = await axios.get(API_GET_EMPLOYEE_FILE, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params: { filepath },
        responseType: "blob",
      });

      if (res.status === 200) {
        const fileBlob = new Blob([res.data], {
          type: res.data.type || "application/pdf",
        });
        const fileURL = window.URL.createObjectURL(fileBlob);

        setDocumentDetail({
          url: fileURL,
          type: res.data.type || "application/pdf",
          name: name || "Document",
        });
      }
    } catch (error) {
      console.error("Error fetching file:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  useEffect(() => {
    if (documentDetail.url) {
      const openModalButton = document.getElementById("open-document-view");
      if (openModalButton) openModalButton.click();
    }
  }, [documentDetail.url]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const years = getYearsUpToCurrent(2020).map((year) => ({
    value: year,
    label: year,
  }));

  useEffect(() => {
    fetchListEmployee();
  }, []);

  const fetchListEmployee = () => {
    setIsEmployeeLoading(true);
    getApi(GET_EMPLOYEE_LIST, accessToken)
      .then((res) => {
        if (res.status === 200) {
          setEmployeeList(res.data.data);
          setIsEmployeeLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setIsEmployeeLoading(false);
      });
  };

  const optionList = employeeList?.map((item) => ({
    value: item.id,
    label: item.empName,
    type: item.employeeType,
  }));

  const Option = (props) => {
    const { data } = props;
    const { label, type } = data;

    return (
      <components.Option {...props}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>{label}</span>
          <span style={{ fontSize: "12px", color: "gray" }}>({type})</span>
        </div>
      </components.Option>
    );
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchListReimbursement();
  }, [currentPage, limit]);

  useEffect(() => {
    if (
      !selectedYear &&
      !selectedMonth &&
      !selectedStatus &&
      !selectedEmployee
    ) {
      fetchListReimbursement();
    }
  }, [selectedYear, selectedMonth, selectedStatus, selectedEmployee]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      setCurrentPage(1);
      getApi(
        API_EMPLOYEE_REIMBURSEMENT_LIST +
          `?empId=${param(selectedEmployee?.value)}
     &status=${param(selectedStatus?.value)}
     &year=${param(selectedYear?.value)}
     &month=${param(selectedMonth?.value)}
     &pageSize=${limit}
     &page=${currentPage}`,
        accessToken,
      )
        .then((res) => {
          if (res.status === 200) {
            setReimbursementList(res.data.data);
            setFilteredItems(res.data.data);
            setTotalReimbursement(res.data.totalRequest);
            setTotalPages(res.data.totalPages);
            setIsLoading(false);
          }
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const fetchListReimbursement = async () => {
    try {
      setIsLoading(true);
      getApi(
        API_EMPLOYEE_REIMBURSEMENT_LIST +
          `?empId=${param(selectedEmployee?.value)}&status=${param(
            selectedStatus?.value,
          )}&year=${param(selectedYear?.value)}&month=${param(
            selectedMonth?.value,
          )}&pageSize=${limit}&page=${currentPage}`,
        accessToken,
      )
        .then((res) => {
          if (res.status === 200) {
            setReimbursementList(res.data.data);
            setFilteredItems(res.data.data);
            setTotalReimbursement(res.data.totalRequest);
            setTotalPages(res.data.totalPages);
            setIsLoading(false);
          }
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
    const sortedData = [...filteredItems].sort((a, b) => {
      if (key === "requestDate" || key === "date") {
        const dateA = new Date(a[key]);
        const dateB = new Date(b[key]);
        if (dateA < dateB) {
          return direction === "ascending" ? -1 : 1;
        }
        if (dateA > dateB) {
          return direction === "ascending" ? 1 : -1;
        }
        return 0;
      } else {
        if (a[key] < b[key]) {
          return direction === "ascending" ? -1 : 1;
        }
        if (a[key] > b[key]) {
          return direction === "ascending" ? 1 : -1;
        }
        return 0;
      }
    });

    setFilteredItems(sortedData);
  };

  return (
    <div className="wrapper-body">
      {isEmployeeLoading && (
        <div className="overlay">
          <div className="loader-container">
            <TailSpin
              height="100"
              width="100"
              radius="1"
              color="blue"
              ariaLabel="tail-spin-loading"
              visible={true}
            />
          </div>
        </div>
      )}
      {/* Page Heading */}
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
        <div className="total">
          Total Reimbursement : <span>{totalReimbursement}</span>
        </div>
      </div>

      <form id="assign-asset">
        <div className="inputs">
          <div className="row">
            <div className="filters">
              <div className="filter">
                <label className="label">Employee Name</label>
                <div className="search">
                  {" "}
                  <Select
                    options={optionList}
                    components={{ Option }}
                    onChange={(option) => {
                      setSelectedEmployee(option);
                      setSearchTerm("");
                    }}
                    className="width-100 pr"
                    value={selectedEmployee}
                    placeholder="Select Employee Name"
                    isSearchable={true}
                    isRequired={true}
                    isClearable
                  />
                </div>
              </div>
              <div className="filter">
                {" "}
                <label className="label"> Status</label>
                <div className="search">
                  <Select
                    id="status"
                    required
                    name="status"
                    className="width-100 pr"
                    value={selectedStatus}
                    placeholder=" Select Status"
                    onChange={(option) => {
                      setSelectedStatus(option);
                      setSearchTerm("");
                    }}
                    options={[
                      { value: "PENDING_ADMIN", label: "Pending Admin" },
                      { value: "PENDING_FINANCE", label: "Pending  Finance" },
                      { value: "DISCREPANCY", label: "Discrepancy" },
                      { value: "PAID", label: "Paid" },
                      { value: "WITHDRAW", label: "Withdraw" },
                      { value: "APPROVED", label: "Approved" },
                      { value: "REJECTED", label: "Rejected" },
                    ]}
                    isClearable
                  />
                </div>
              </div>

              <div className="filter">
                {" "}
                <label className="label"> Year</label>
                <div className="search">
                  <Select
                    options={years}
                    value={selectedYear}
                    onChange={(year) => {
                      setSelectedYear(year || null);
                      setSelectedMonth(null);
                    }}
                    placeholder="Select Year"
                    className="width-100 pr"
                    isClearable
                  />
                </div>
              </div>
              {selectedYear && (
                <div className="filter">
                  <label className="label"> Month</label>
                  <div className="search">
                    <Select
                      options={months}
                      value={selectedMonth}
                      onChange={(month) => setSelectedMonth(month || null)}
                      placeholder="Select Month"
                      className="width-100 pr"
                      isClearable
                    />
                  </div>
                </div>
              )}

              {/* <button type="submit" form="form_filters">
          Search
        </button> */}
              {/* </form> */}
              <div className="actions">
                <button
                  type="button"
                  className="theme-button py-2"
                  onClick={handleSubmit}
                >
                  Filter
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>

      {isLoading && !isEmployeeLoading && (
        <div className="centered-loader">
          <ThreeDots
            height="100"
            width="100"
            radius="9"
            color="blue"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}

      {/* Data Table */}
      {!isLoading && filteredItems?.length > 0 && (
        <>
          <SortableTable
            columns={columns}
            data={filteredItems}
            currentPage={currentPage}
            limit={limit}
          />
          <div className="row">
            <div className="col-md-3">
              <div>
                {/* Dropdown for selecting items per page */}
                <label htmlFor="itemsPerPage">Items per page </label>
                <select
                  id="itemsPerPage"
                  onChange={handleLimitChange}
                  value={limit}
                  className="border ms-3 w-25  p-2"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                </select>
              </div>
            </div>
            <div className="col-md-9">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </>
      )}

      {!isLoading && filteredItems?.length === 0 && (
        <div className="fs-4 text-secondary text-center">
          <h4>No Record Available</h4>
        </div>
      )}

      <button
        id="open-document-view"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropDocumentViewer"
        style={{ display: "none" }}
      ></button>

      {documentDetail.url && (
        <DocumentViewer
          url={documentDetail.url}
          contentType={documentDetail.type}
          fileName={documentDetail.name}
        />
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ReimbursementHistory;
